import { render, staticRenderFns } from "./ComplaintCreationThirdStepForm.vue?vue&type=template&id=4a07226d&scoped=true&lang=pug&"
import script from "./ComplaintCreationThirdStepForm.vue?vue&type=script&lang=ts&"
export * from "./ComplaintCreationThirdStepForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComplaintCreationThirdStepForm.vue?vue&type=style&index=0&id=4a07226d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07226d",
  null
  
)

export default component.exports